import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';

import React from 'react';
import PropTypes from 'prop-types';
import { LIMIT_HIGH_VOLUME_SHIPMENTS_8 } from '../../../constants';
import messages from './messages';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';
import { HelpArticleLink } from '../../../../../../components/help-article-link';
import { linkIDs } from '../../../../../../services/link-service/links';
import { getDollarValueAsCents } from '../../../../../../services/decimal-display-service';
import { isBillingPlanIdUsageBilledHighVolume, HighVolumePlanToUsagePriceMap } from '../../../../../../enums/billing-plan-ids';
import style from '../../../style.module.less';

// it should be noted that this footer is strictly for US HV plans, non-US usage fees are conveyed inside plan selection. Hence the hard-coding of currency.
const PricePerLabelMessaging = ({ currentBillingPlan = {}, allPlans = [] }) => {
  const highVolumePlan = allPlans.find((plan) => plan?.shipmentLimit?.limitCode === LIMIT_HIGH_VOLUME_SHIPMENTS_8) || {};
  const { name, code, billingPlanId } = highVolumePlan;
  const currentPlanNameDoesNotMatchPricePerLabelPlan = name !== currentBillingPlan?.name; // this is like "High Volume" !== "High Volume" for comparing between two different high volume plans
  const currentPlanHasUsageFees = isBillingPlanIdUsageBilledHighVolume(currentBillingPlan?.billingPlanId);

  // The OR here is needed to cover the case where the seller is on an older
  // version of the high volume plan that does not have per label pricing.
  // In that case the user should not see the footnote. - Greg S 7/18/23
  const showFootnote = code && (currentPlanNameDoesNotMatchPricePerLabelPlan || currentPlanHasUsageFees);
  if (!showFootnote) {
    return null;
  }

  const fee = HighVolumePlanToUsagePriceMap[billingPlanId] || HighVolumePlanToUsagePriceMap[currentBillingPlan?.billingPlanId] || 0;
  const feeAsCents = getDollarValueAsCents(fee);

  if (showFootnote) {
    return (
      <Text
        className={style['subscription-modal-footer-text']}
        element='span'
        formattedMessageValues={{
          kb: (chunks) => (
            <HelpArticleLink articleId={linkIDs.CarrierIntegrations} className={style['footnote-link']}>
              {chunks}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </HelpArticleLink>
          ),
          fee: feeAsCents,
        }}
        textType={TextType.Caption}
        value={messages.highVolumeShipmentExternalCarrierPerLabelPriceFootnote}
      />
    );
  }
};

PricePerLabelMessaging.propTypes = {
  allPlans: PropTypes.array,
  currentBillingPlan: PropTypes.object,
};

export const PricePerLabelFootnote = React.memo(PricePerLabelMessaging);
